export type MediaType = 'IMAGES' | 'FILES' | 'FYUSE';
export type MediaImageResource = { href: string; sequence?: number; angle?: MediaImageAngle | null };
export type MediaFileResource = { href: string };
export type MediaFyuseResource = { uploadId: string; sessionId?: string };

export type MediaBase<TMediaType extends MediaType> = {
  href: string;
  unit: {
    href: string;
  };
  type: TMediaType;
  source: string;
  resource: TMediaType extends 'IMAGES'
    ? MediaImageResource
    : TMediaType extends 'FILES'
    ? MediaFileResource
    : TMediaType extends 'FYUSE'
    ? MediaFyuseResource
    : unknown;
  updatedOn: string;
  createdOn: string;
};

export type MediaImage = MediaBase<'IMAGES'>;
export type MediaFile = MediaBase<'FILES'>;
export type MediaFyuse = MediaBase<'FYUSE'>;

export type Media = MediaImage | MediaFile | MediaFyuse;

export type MediaImageAngle = typeof MEDIA_IMAGE_ANGLES[number][0];
export const MEDIA_IMAGE_ANGLES = [
  ['FRONT_LEFT', 'Left Front', 'exterior'],
  ['REAR_LEFT', 'Left Rear', 'exterior'],
  ['FRONT', 'Front', 'exterior'],
  ['REAR', 'Rear', 'exterior'],
  ['REAR_RIGHT', 'Right Rear', 'exterior'],
  ['FRONT_RIGHT', 'Right Front', 'exterior'],
  ['3RD_ROW_SEAT', '3rd Row Seat', 'interior'],
  ['LEFT_FRONT_INTERIOR', 'Left Front Interior', 'interior'],
  ['LEFT_REAR_INTERIOR', 'Left Rear Interior', 'interior'],
  ['DASHBOARD', 'Center Dashboard', 'interior'],
  ['ODOMETER', 'Odometer', 'interior'],
  ['RIGHT_FRONT_INTERIOR', 'Right Front Interior', 'interior'],
  ['STEERING_WHEEL', 'Steering Wheel', 'interior'],
  ['SUNROOF', 'Sunroof', 'interior'],
  ['MFG_TAG', 'Manufacturer Tag', 'interior'],
  ['CARGO', 'Cargo', 'interior'],
  ['DRIVER_DOOR_PANEL', 'Door Panel', 'interior'],
  ['ENGINE', 'Engine', 'interior'],
  ['DAMAGE', '', 'damage']
] as const;
export const MEDIA_IMAGE_ANGLE = MEDIA_IMAGE_ANGLES.reduce(
  (acc, angle) => ({
    ...acc,
    [angle[0]]: { angle: <MediaImageAngle>angle[0], label: <string>angle[1], section: <string>angle[2] }
  }),
  {} as { [K in MediaImageAngle]: { angle: K; label: string; section: string } }
);
/*[
  'PRIMARY_IMAGE',
  'OTHER_IMAGE',
  'FRONT_LEFT',
  'REAR_LEFT',
  'FRONT_RIGHT',
  'REAR_RIGHT',
  'WHEEL',
  'INTERIOR_FRONT',
  'DASHBOARD',
  'ENGINE',
  'ODOMETER',
  'INTERIOR_REAR',
  'MFG_TAG',
  'CARGO',
  'UNKNOWN',
  'DAMAGE',
  'WO_STICKER',
  'FRONT',
  'REAR',
  'REAR_FRONT_INTERIOR',
  'DRIVER_DOOR_PANEL',
  'STEERING_WHEEL',
  '3RD_ROW_SEAT',
  'SUNROOF'
]*/
